import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import { truncate } from 'lodash/string';

class FeaturedOrgCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let category = this.props.category;
    let category_root = this.props.category_root;
    let db_id = this.props.db_id;
    let slug = this.props.slug;
    let name = this.props.name;
    let thumbnail_text = this.props.thumbnail_text;

    let orgDetailUrl = "/organizations/" + db_id + "/" + slug



    thumbnail_text = truncate(thumbnail_text,{
      'length': 200,
      'separator': /,? +/
    });


    let image_icon = this.props.image_icon;
    let image_home_feature = this.props.image_home_feature;

    return(
      <main>
        <div className="featuredOrgCard">
          <Link to={orgDetailUrl}><div className="featuredOrgCard-innerWrapper">
            <div className="featuredOrgCard-banner">
              <div className="featuredOrgCard-imgFilter"><img src="images/home/shim_featuredOrgs.gif" /></div>
              <div className="featuredOrgCard-img"><img src={image_home_feature} /></div>
            </div>
            <div className="featuredOrgCard-body">
              <div className="featuredOrgCard-category">
                {category_root}
              </div>
              <div className="featuredOrgCard-name">{name}</div>
              <div className="featuredOrgCard-copy-wrapper">
                <div className="featuredOrgCard-copy">
                  <div className="featuredOrgCard-logo">
                    <img src={image_icon} />
                  </div>
                  {thumbnail_text}
                </div>

              </div>
            </div>

          </div></Link>
        </div>
      </main>
    )
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps
)(FeaturedOrgCard);



// WEBPACK FOOTER //
// ./src/components/featuredOrgsHomePage/FeaturedOrgCard.jsx